import eventHandlers from "../../components/retention/webpush/eventHandlers";

async function init() {
    eventHandlers.init();
}

export function hasWebpushSupport() {
    return 'serviceWorker' in navigator && 'PushManager' in window;
}

export function hasWebpushConsent() {
    return Notification.permission !== 'default';
}

export default {
    init,
};
